import { SxProps, Theme, alpha } from '@mui/material';

export const richTextEditorContainerSX: SxProps<Theme> = {
  '> *': { boxSizing: 'border-box' },
  '> div[aria-expanded]': { height: '100%' },
  width: '100%',
  overflow: 'auto',
  minHeight: '40px',
  '.ProseMirror': {
    cursor: 'text',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    ':focus': {
      outline: 0,
    },
  },
  ' p': {
    marginBlockEnd: '8px',
    marginBlockStart: '10px',
    marginInlineEnd: 0,
    marginInlineStart: 0,
  },
  ' blockquote': {
    paddingLeft: '1rem',
    borderLeft: (theme) =>
      `2px solid ${alpha(theme.palette.text.secondary, 0.2)}`,
  },
  '.tiptap .is-editor-empty:first-child::before': {
    color: (theme) => alpha(theme.palette.text.disabled, 0.4),
    content: 'attr(data-placeholder)',
    float: 'left',
    height: 0,
    pointerEvents: 'none',
  },
};
